import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';
import { useTranslation, Trans } from 'react-i18next';
import { Alert, Box, DialogContent, Typography } from '@mui/material';
import { WButton } from '@wareclouds/wareclouds-ui';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useMemo } from 'react';
import getCitiesNames from '../../../../utils/getCitiesName';

function EnabledRouteDialog({
  open,
  title,
  handleClose,
  handleAssignRoute,
  isLoading,
  selectedRoute,
}) {
  const { t } = useTranslation(['button']);
  const cityNames = useMemo(
    () => getCitiesNames(selectedRoute?.cities || []),
    [selectedRoute]
  );

  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xs"
      slotProps={{
        paper: {
          sx: {
            px: 2,
            py: 3,
          },
        },
      }}
    >
      <DialogTitle id="alert-dialog-title" sx={{ px: 0, pt: 0 }}>
        {title}
      </DialogTitle>
      <DialogContent sx={{ px: 0 }}>
        <Typography variant="body2">
          {t('routes.confirm_modal.description', { ns: 'description' })}
        </Typography>
        {selectedRoute && (
          <Typography variant="body2" sx={{ mt: 2 }}>
            <LocationOnIcon
              sx={{ verticalAlign: 'middle', mr: 1, color: 'text.secondary' }}
            />
            <Trans
              t={t}
              ns="description"
              i18nKey="routes.confirm_modal.delivery_point"
              values={{
                list_destinations: cityNames,
              }}
              components={[<Box component="span" sx={{ fontWeight: 500 }} />]}
            />
          </Typography>
        )}
        <Alert severity="warning" sx={{ mt: 2 }}>
          <Trans
            t={t}
            ns="description"
            i18nKey="routes.confirm_modal.warning"
            components={[<Box component="span" sx={{ fontWeight: 500 }} />]}
          />
        </Alert>
      </DialogContent>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <WButton
          label={
            isLoading ? (
              <CircularProgress size={20} />
            ) : (
              t('confirm', { ns: 'button' })
            )
          }
          onClick={handleAssignRoute}
          color="primary"
          fullWidth
          disabled={isLoading}
          variant={'contained'}
        />
        <WButton
          label={t('back', { ns: 'button' })}
          onClick={handleClose}
          fullWidth
          variant={'contained'}
          sx={{
            color: 'black',
            bgcolor: 'grey.300',
          }}
        />
      </Box>
    </Dialog>
  );
}

export default EnabledRouteDialog;
